const Header = () => {

    return (
        <header>
            <h1>BEAT THE MACHINE</h1>
        </header>
    )
}

export default Header;